import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShoppingOutlined } from "@ant-design/icons";

import ContentTitle from "../../../components/ContentTitle/ContentTitle";
import Spinner from "../../../components/Spinner/Spinner";
import OrdersTable from "../../../components/OrdersTable/OrdersTable";

import {
  selectOrders,
  selectIsOrdersLoading,
} from "../../../redux-toolkit/orders/orders-selector";
import { resetOrders } from "../../../redux-toolkit/orders/orders-slice";
import { fetchUserOrdersByEmail } from "../../../redux-toolkit/orders/orders-thunks";
import { RootState, AppDispatch } from "../../../store";

const PersonalOrdersList: FC = (): ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const orders = useSelector(selectOrders);
  const isOrdersLoading = useSelector(selectIsOrdersLoading);
  const userEmail = useSelector(
    (state: RootState) => state.user.user?.email
  );

  useEffect(() => {
    if (userEmail) {
      dispatch(fetchUserOrdersByEmail({ email: userEmail, page: 0 }));
    }
    return () => {
      dispatch(resetOrders());
    };
  }, [dispatch, userEmail]);

  return (
    <div>
      <ContentTitle title="My Orders" icon={<ShoppingOutlined />} />
      {isOrdersLoading ? (
        <Spinner />
      ) : (
        <OrdersTable
          loading={isOrdersLoading}
          orders={orders}
          fetchOrders={fetchUserOrdersByEmail}
          userEmail={userEmail || ""}
        />
      )}
    </div>
  );
};

export default PersonalOrdersList;
